<template>
  <div class="col s12 l8">
    <div class="card indigo lighten-1 bill-card">
      <div class="card-content white-text">
        <div class="card-header">
          <span class="card-title">{{'CurrencyAmountTitle' | localize}}</span>
        </div>
        <table>
          <thead>
            <tr>
              <th>{{'Currency' | localize}}</th>
              <th>{{'CurrencyType' | localize}}</th>
              <th>{{'Date' | localize}}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="currency in currencies" :key="currency">
              <td>{{currency}}</td>
              <td>{{parseInt(rates[currency] * 100) / 100}}</td>
              <td>{{date | date('date')}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media screen and (max-width: 330px) {
  table {
    font-size: 11.7px;
  }
}
</style>

<script>
export default {
  props: ["rates", "date"],
  data: () => ({
    currencies: ["UAH", "USD", "EUR"]
  })
};
</script>